// Components==============
import React from 'react';
import './Token.module.scss';
// =========================

export default function Token({
  token,
  final,
}: {
  token: { thumbnail: string };
  final: 'final' | 'default';
}) {
  return (
    <div styleName={`token-wrapper ${final ? 'final' : 'default'}`}>
      <div>
        <img
          src={`${token?.thumbnail}`}
          alt={token?.thumbnail}
          styleName="token-image"
        />
      </div>
    </div>
  );
}
